var map = {
	"./decidim/avatar-multiuser.png": 20201,
	"./decidim/brands/google.svg": 60388,
	"./decidim/cc-badge.png": 36543,
	"./decidim/decidim-logo.svg": 47035,
	"./decidim/default-avatar.svg": 85791,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 98725,
	"./decidim/icons.svg": 16638,
	"./decidim/pattern.png": 45581,
	"./decidim/placeholder-card-g.svg": 57730,
	"./decidim/placeholder-card-l.svg": 9385,
	"./decidim/placeholder.jpg": 85720,
	"./decidim/remixicon.symbol.svg": 80762,
	"./decidim/vendor/leaflet/layers-2x.png": 34583,
	"./decidim/vendor/leaflet/layers.png": 31070,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 64019,
	"./decidim/vendor/leaflet/marker-icon.png": 85226,
	"./decidim/vendor/leaflet/marker-shadow.png": 38233,
	"./decidim/vendor/social-share-button/douban.svg": 41821,
	"./decidim/vendor/social-share-button/email.svg": 90302,
	"./decidim/vendor/social-share-button/facebook.svg": 71638,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 43738,
	"./decidim/vendor/social-share-button/hacker_news.svg": 14190,
	"./decidim/vendor/social-share-button/linkedin.svg": 15412,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 84877,
	"./decidim/vendor/social-share-button/pinterest.svg": 1288,
	"./decidim/vendor/social-share-button/reddit.svg": 12450,
	"./decidim/vendor/social-share-button/telegram.svg": 83971,
	"./decidim/vendor/social-share-button/tumblr.svg": 84064,
	"./decidim/vendor/social-share-button/twitter.svg": 26243,
	"./decidim/vendor/social-share-button/vkontakte.svg": 68233,
	"./decidim/vendor/social-share-button/wechat.svg": 1884,
	"./decidim/vendor/social-share-button/whatsapp.svg": 39540,
	"./decidim/vendor/social-share-button/x.svg": 16454,
	"./decidim/vendor/social-share-button/xing.svg": 4722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24122;